import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import GlobalFormMessage from '~/components/atoms/forms/basis/GlobalFormMessage';



const messages = defineMessages({
	['expired_card']: {
		id: 'ui.recurlyErrors.cardExpired',
	},
	['insufficient_funds']: {
		id: 'ui.recurlyErrors.insufficientFunds',
	},
	fallback: {
		id: 'ui.recurlyErrors.cardDeclined',
	},
});



type Props = {
	errorCode: string,
};

const PaymentFailureFormError: React.FC<Props> = (props) => {
	const {
		errorCode,
	} = props;

	return (
		<GlobalFormMessage name={errorCode}>
			{({ globalError }) => {
				const errorCode = globalError.details.declineCode ?? globalError.details;

				return (
					<FormattedMessage
						{...messages[errorCode] ?? messages.fallback}
					/>
				);
			}}
		</GlobalFormMessage>
	);
};



export default PaymentFailureFormError;
